import styled, { css } from 'styled-components'
import { gray_7, gray_6, white } from '../../theme/colors'
import { xsMd } from '../../theme/utils/media-query'
import { spacing_0_5, spacing_1, spacing_1_5, spacing_2_5, spacing_5 } from '../../theme/spacing'
import { border_width_3 } from '../../theme/border';
import { softForSite, primaryForSite } from '../../theme/colors';
import { transition } from '../../theme/animations';
import { h4_bold } from '../../theme/type-styles';
import { border_radius_1 } from '../../theme/border';
import { level_8 } from '../../theme/box-shadow';
import { spacing_3 } from '../../theme/spacing';

export function makeNav (element) {
  return styled(element)`
    background: ${ white };
    height: ${ spacing_5 };
    color: ${ gray_6 };
    ${props => props.fixed && css`
      position: fixed;
    `}
    box-shadow: ${ level_8 };
    width: 100%;
    height: 80px;
    z-index: 2;
    transition: height 300ms ease;
    ${ h4_bold };

    .main-nav {
      margin: 0 ${ spacing_3 };
      a {
        color: ${gray_6};
        &:hover {
          color: ${props => primaryForSite('careguide.com')};
          text-decoration: none;
        }
      }
    }

    // Required to allow spacing between dropdown and header
    // but not closing between hover of header and dropdown
    .dropdown-bounding-box {
      display: none;
      position: absolute;
      padding-top: 10px;
      top: ${ props => props.dropdownTopPosition || '80px' };
      background: transparent;
    }

    .nav-dropdown {
      text-align: left;
      background: white;
      box-shadow: ${ level_8 };
      border-radius: ${border_radius_1};
      padding: ${spacing_0_5} 0;
      min-width: 160px;
      z-index: 2;

      a {
        display: block;
        cursor: pointer;
        padding: ${spacing_1};
        font-weight: normal;
        color: ${ gray_6 };
        transition: color 0.1s, background 0.1s;

        &:hover {
          transition: color 0.1s, background 0.1s;
          text-decoration: none;
          color: ${ gray_7 };
          background-color: rgb(229, 243, 243);
        }
      }
    }

    & > * {
      height: 100%;
    }

    .mobile-nav {
      overflow-y: scroll;
      -webkit-overflow-scrolling:touch;
    }

    .logo {
      padding: ${ spacing_1_5 } 0;
      height: 48px;
      transition: height 0.3s ease;
    }

    .nav-section {
      cursor: pointer;
      margin-right: ${ spacing_2_5 };
      display: flex;
      height: 100%;
      align-items: center;

      .link {
        padding: ${ spacing_1_5 } 0;
      }

      &.last {
        margin-right: 0px;
        color: ${ gray_6 };
      }

      &.selected {
        color: ${props => primaryForSite('careguide.com')};
        border-bottom: ${ border_width_3 } solid ${props => primaryForSite('careguide.com')};
      }

      &:hover {
        transition: ${ transition };
        color: ${props => primaryForSite('careguide.com')};
        border-bottom: ${ border_width_3 } solid ${props => primaryForSite('careguide.com')};
        & .dropdown-bounding-box {
          display: block;
        }
      }
    }

    .nav-section:hover {
      & .dropdown-bounding-box {
        display: block;
      }
    }

    ${xsMd(css`
      transition: height 0.3s ease;
      height: 48px;
      .nav-links {
        display: none;
      }
      .main-nav {
        margin: 0 ${ spacing_1 };
      }
      .mobile-nav {
        display: block;
        height: auto;
      }
      .open {
        height: calc(100vh - 48px);
      }
      .logo {
        padding: ${ spacing_1 } 0;
        img {
          // This should preferably be a transform;
          height: 16px;
          transition: height 0.3s ease;
        }
      }
    `)}
  `
}

export default makeNav